(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('journal-tabs')) {
    customElements.define('journal-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const nav = this.querySelector('.journal-feature__nav');
        const tabs = Array.from(this.querySelectorAll('[data-journal-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-journal-panel]'));
        if (!nav || !tabs.length || tabs.length !== panels.length) return;
        this.dataset.initialized = 'true';
        nav.setAttribute('role', 'tablist');
        tabs.forEach((tab) => {
          const panel = panels.find((item) => item.dataset.journalPanel === tab.dataset.journalTab);
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
          tab.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            activate(tab);
          });
          tab.addEventListener('keydown', (event) => {
            const index = tabs.indexOf(tab);
            const keys = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 };
            if (event.key === ' ') { event.preventDefault(); activate(tab); return; }
            if (!(event.key in keys)) return;
            event.preventDefault();
            tabs[keys[event.key]].focus();
            activate(tabs[keys[event.key]]);
          });
        });
        const activate = (selected) => {
          tabs.forEach((tab) => {
            const active = tab === selected;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.journalPanel !== selected.dataset.journalTab; });
        };
        this.classList.add('is-enhanced');
        activate(tabs[0]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const megaHeaders = new WeakMap();
function initialiseMegaMenus(root = document) {
  root.querySelectorAll('[data-header]').forEach(header => {
    if (megaHeaders.has(header)) return;
    const controller = new AbortController();
    megaHeaders.set(header, controller);
    const signal = controller.signal;
    const menus = [...header.querySelectorAll('[data-mega-menu]')];
    const wide = window.matchMedia('(min-width: 1100px)');
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const states = new Map(menus.map(menu => [menu, {openTimer: null, closeTimer: null, hoverOpened: false}]));
    const clearTimers = menu => {
      const state = states.get(menu);
      clearTimeout(state.openTimer);
      clearTimeout(state.closeTimer);
    };
    const sync = menu => menu.querySelector(':scope > summary').setAttribute('aria-expanded', String(menu.open));
    const close = (menu, restoreFocus = false) => {
      clearTimers(menu);
      menu.open = false;
      states.get(menu).hoverOpened = false;
      sync(menu);
      if (restoreFocus) menu.querySelector(':scope > summary').focus();
    };
    const open = (menu, hoverOpened = false) => {
      menus.filter(other => other !== menu).forEach(other => close(other));
      clearTimers(menu);
      menu.open = true;
      states.get(menu).hoverOpened = hoverOpened;
      sync(menu);
    };
    menus.forEach(menu => {
      const summary = menu.querySelector(':scope > summary');
      const state = states.get(menu);
      sync(menu);
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.filter(other => other !== menu && other.open).forEach(other => close(other));
        sync(menu);
      }, {signal});
      summary.addEventListener('click', event => {
        clearTimers(menu);
        if (state.hoverOpened && menu.open) event.preventDefault();
        state.hoverOpened = false;
      }, {signal});
      menu.addEventListener('pointerenter', event => {
        if (!wide.matches || !pointer.matches || event.pointerType !== 'mouse') return;
        clearTimers(menu);
        if (!menu.open) state.openTimer = setTimeout(() => open(menu, true), 120);
      }, {signal});
      menu.addEventListener('pointerleave', event => {
        if (!wide.matches || !pointer.matches || event.pointerType !== 'mouse') return;
        clearTimers(menu);
        state.closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(menu); }, 220);
      }, {signal});
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          event.stopPropagation();
          close(menu, true);
        }
      }, {signal});
      menu.addEventListener('focusout', event => {
        if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
        setTimeout(() => { if (menu.open && !menu.contains(document.activeElement)) close(menu); }, 0);
      }, {signal});
      menu.addEventListener('click', event => {
        if (event.target.closest('a[href]')) close(menu);
      }, {signal});
    });
    document.addEventListener('pointerdown', event => {
      menus.filter(menu => menu.open && !menu.contains(event.target)).forEach(menu => close(menu));
    }, {signal});
    header.querySelectorAll('.desktop-nav > a').forEach(link => {
      link.addEventListener('pointerenter', () => { if (wide.matches && pointer.matches) menus.forEach(menu => close(menu)); }, {signal});
    });
    header.querySelector('[data-mobile-menu]')?.addEventListener('toggle', event => {
      if (!event.currentTarget.open) menus.forEach(menu => close(menu));
    }, {signal});
    wide.addEventListener('change', () => menus.forEach(menu => close(menu)), {signal});
    document.addEventListener('shopify:block:select', event => {
      if (!header.contains(event.target)) return;
      const menu = menus.find(item => item.dataset.megaBlock === event.detail.blockId && !!item.getClientRects().length);
      if (menu) open(menu);
    }, {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(header)) {
        menus.forEach(menu => clearTimers(menu));
        controller.abort();
        megaHeaders.delete(header);
      }
    }, {signal});
  });
}
initialiseMegaMenus();
document.addEventListener('shopify:section:load', event => initialiseMegaMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockist-directory"] && !Shopify.designMode) return;
  try {
    
function initialiseStockistDirectories(root) {
  root.querySelectorAll('[data-stockist-directory]').forEach(directory => {
    if (directory.dataset.initialised) return;
    directory.dataset.initialised = 'true';
    const input = directory.querySelector('[data-stockist-search]');
    const rows = [...directory.querySelectorAll('[data-stockist-row]')];
    const count = directory.querySelector('[data-stockist-count]');
    const empty = directory.querySelector('[data-stockist-empty]');
    const normalise = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const filterRows = () => {
      const terms = normalise(input.value).split(' ').filter(Boolean);
      let visible = 0;
      rows.forEach(row => {
        const text = normalise(row.dataset.search);
        row.hidden = !terms.every(term => text.includes(term));
        if (!row.hidden) visible += 1;
      });
      count.textContent = count.dataset.resultsLabel.replace('__COUNT__', String(visible));
      empty.hidden = visible > 0;
    };
    input.addEventListener('input', filterRows);
    filterRows();
  });
}
initialiseStockistDirectories(document);
document.addEventListener('shopify:section:load', event => initialiseStockistDirectories(event.target));

  } catch(e) { console.error(e); }
})();
})();
